<template>
  <div class="login-page" :class="{hasimg: destImgSrc}">
    <h1>colorinco α</h1>
    <div class="destimg-box" v-show="destImgSrc">
      <img :src="destImgSrc" class="destimg">
    </div>
    <h2>❤️な色を見つけよう</h2>
    <div class="instruction">
      「カラーインコ」はTwitterに投稿した画像やお気に入りした画像からカラーパレットを表示・ストックできるアプリです。
      すべて無料でご利用いただけますが、予告なくサービスを停止・終了することがあります。
    </div>
    <h2>{{ loginTitle }}</h2>
    <div class="instruction">
      このアプリではユーザのツイートとお気に入りの一覧を取得するため、Twitterタイムラインの読み取り権限が必要です。
      勝手にツイートしたり誰かをフォローしたりすることはありません。
      ご不明な点は<a href="https://twitter.com/yuneco" target="_blank">作者(@yuneco)</a>までご連絡ください。
    </div>
    <div class="btns">
      <button class="loginButton" @click="twlogin">Login with Twitter</button>
    </div>
    <color-bg></color-bg>
  </div>
</template>

<style scoped>
.login-page {
  padding: 0px;
}
h1{
  margin: 0;
  padding: 20px;
  color: #2c3e50;
}
.hasimg h1{
  font-size: 16pt;
  padding: 5px;
}
h2{
  margin: 5px 0 2px 0;
  text-align: center;
  font-size: 11pt;
  color: #2c3e50;
}
.destimg{
  width: 96%;
  border: 1px solid gray;
}
.instruction {
  color: #2c3e50;
  font-size: 8pt;
  padding: 0 20px;
}
.instruction a{
  color: rgb(106, 54, 63);
}
.btns{
  text-align: center;
  padding: 30px;
}
.loginButton{
  border: 2px solid #2c3e50;
  color: #2c3e50;
  font-size: 16pt;
  background: #ffffff80;
  padding: 5px 10px;
  border-radius: 5px;
  position: relative;
  z-index: 2;
}
</style>

<script>
import UserApi from '@/api/UserApi'
import ColorBg from '@/components/ColorBg'
export default {
  name: 'LoginPage',
  components: {ColorBg},
  data () {
    return {
      destImgSrc: null
    }
  },
  computed: {
    loginTitle () {
      return 'Twitterログインが必要です'
    }
  },
  methods: {
    twlogin () {
      const query = document.location.search
      this.$router.push(`WaitAuthResult${query}`, () => {
        UserApi.loginWithTwitter()
      })
    },
    getDest () {
      return decodeURIComponent((document.location.search || '?').substr(1))
    }
  },
  mounted () {
    const dest = this.getDest()
    if (dest.startsWith('stock/')) {
      const matRes = dest.match(/^stock\/(.*)$/)
      const stockid = matRes ? matRes[1] : null
      console.log(stockid)
      if (stockid) {
        this.destImgSrc = `/ogp/stockimg/${stockid}`
      }
    }
    UserApi.getToken().then(() => {
      this.$router.push(dest || 'myimgs')
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/LoginPage.vue